// Only a public studio slug is cached. Account preferences and access are server-owned.
const safe = value => typeof value === 'string' && /^[a-z0-9-]{1,160}$/i.test(value);
export function cachedBrandHome(brand) {
  try { const slug=window.localStorage.getItem(`tps:brand-home:${brand}`); return safe(slug)?slug:''; } catch { return ''; }
}
export function cacheBrandHome(brand,home) {
  try {
    if(safe(brand)&&safe(home?.slug))window.localStorage.setItem(`tps:brand-home:${brand}`,home.slug);
    else if(safe(brand))window.localStorage.removeItem(`tps:brand-home:${brand}`);
  } catch { /* Navigation still works without Web Storage. */ }
  window.dispatchEvent(new window.Event('tps:brand-home-changed'));
}
export function brandHomeUrl(brand,studio,audience='client') {
  if(!safe(brand)||!safe(studio))return '';
  const query=new URLSearchParams({studio,brand});
  return audience==='client'?`/client?${query}`:`/studio/${encodeURIComponent(studio)}/login?${query}`;
}
export function brandExploreUrl(brand) { return `/brand/${encodeURIComponent(brand)}?view=explore`; }
export function shouldLaunchBrand(search) {
  const params=new URLSearchParams(search);
  if(params.get('view')==='explore'||params.get('view')==='story')return false;
  return params.get('launch')==='1'||Boolean(window.navigator?.standalone)||Boolean(window.matchMedia?.('(display-mode: standalone)').matches);
}
